export const BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const API_BASE_URL = BASE_URL + '/api'
export const PUBLIC_BASE_URL = BASE_URL + '/public';
export const KEYCLOAK_AUTH_URL = 'https://login.fivefaces.com.au/auth';
